import { render } from "./Navigation_Mobile_MenuItem.vue?vue&type=template&id=8b45a6ba"
import script from "./Navigation_Mobile_MenuItem.vue?vue&type=script&lang=js"
export * from "./Navigation_Mobile_MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__